import PropTypes from 'prop-types'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
// import data from '../common/constants/olympicsSports.json'
import MyImage from '@shared/components/myImage'
import { OlympicsLogo } from '@shared/components/ctIcons'
import disciplines from '../common/constants/olympicsSports'

function SportsTable({ dataSSR }) {
  return (
    <section className="widget">
      <div className={`${styles.block} font-semi items common-box mb-0`}>
        <div className={`d-flex align-items-center ${styles.tableBanner}`}>
          <OlympicsLogo />
          <div className={styles.tableCntr}>
            <div className={styles.tableTitle}>SPORTS</div>
            <div className={styles.tableSubTitle}>ROSTER</div>
          </div>
        </div>
        <div className={styles.tableBody}>
          {disciplines?.map?.((ele, index) => (
            <CustomLink href={ele?.hrefLink} prefetch={false} key={index}>
              <a className={`${styles.item} cs-item d-flex py-2 py-md-3 align-items-center`}>
                <div className={`${styles.seriesImg} overflow-hidden rounded-circle`}>
                  <MyImage src={ele?.image} alt={ele.title} />
                </div>
                <div>{ele.title}</div>
              </a>
            </CustomLink>
          ))}
        </div>
      </div>
    </section>
  )
}

SportsTable.propTypes = {
  dataSSR: PropTypes.object
}

export default SportsTable
